import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Services
import GalleryService from '../../services/gallery-service';
import SchoolService from '../../services/school-service';
import StorageService from '../../services/storage-service';

// Containers
import GalleryFollow from './gallery-follow';

// Components
import Loading from '../../components/loading/loading';
import ErrorComponent from '../../components/error/error';

// Galeria não tem agendamento, então não existe o desvio "agendada -> abre o
// formulário de edição" que os comunicados têm: esta rota é sempre a tela de
// acompanhamento, e a edição fica em /galerias/:galleryId/editar.
const GalleryEditFollow = () => {
  const { galleryId } = useParams<{ galleryId: string }>();
  const [error, setError] = useState(false);

  const [gallery, setGallery] = useState<BackofficeGalleryDetailDto>(null);
  const [galleryService, setGalleryService] = useState<GalleryService | null>(null);

  useEffect(() => {
    const schoolService = new SchoolService();
    const storageService = new StorageService();
    const schoolId = storageService.getEmployee().schoolId;

    schoolService
      .getSchoolById(schoolId)
      .then((school) => {
        const service = new GalleryService(school.uuid);

        setGalleryService(service);

        return service.getBackoffice(galleryId);
      })
      .then((detail) => setGallery(detail))
      .catch(() => setError(true));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <ErrorComponent type='contentFull' />;

  if (!gallery || !galleryService) return <Loading type='contentFull' />;

  return <GalleryFollow gallery={gallery} galleryService={galleryService} />;
};

export default GalleryEditFollow;
